<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m6z4PV/tc-custom/9781504020039.jpg?1720464452837" alt="This image is the cover for the book Antietam Assassins, The Harrison Raines Civil War Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Antietam Assassins, The Harrison Raines Civil War Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A Union spy is pulled out of retirement to find a killer in this “action-packed” historical mystery (<i>Publishers Weekly</i>).</b><br/>  <br/> It’s 1862, and as far as Harrison Raines is concerned, the Civil War is finished. Since the First Battle of Bull Run, he has served the Union Army as a spy, crisscrossing the war-torn country and witnessing more death, misery, and carnage than any man should. Although he’s a Virginian, he loathes slavery, and is proud to have served Abraham Lincoln. But Raines has had enough killing, and wishes only to retire to a tranquil patch of land. He acquires a plot in the hills of western Virginia and settles down to the life of the gentleman farmer—but Raines’s days will not remain quiet for long.<br/>  <br/> When a local parson known to have Union sympathies is killed, Raines fears his new neighbors may come after him next. To secure a peaceful retirement, he will have to stare down death one more time . . .<br/>  <br/> “Abundant historical detail and myriad plot twists.” —<i>Kirkus Reviews</i><br/>  <br/> “Colorful characters, an authentic picture of war's brutality, an intriguingly perplexing plot, and a likable, larger-than-life hero make this addition to the Harrison Raines series a top pick for Civil War buffs and fans of historical mysteries.” —<i>Booklist </i><br/>  <br/> The Antietam Assassins<i> is the sixth book in the Harrison Raines Civil War Mysteries, but you may enjoy reading the series in any order.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Kilian
      </h2>
      
      <p class="authorDescription body article">Michael Kilian (1939&ndash;2005) was born in Toledo, Ohio, and was raised in Chicago, Illinois, and Westchester, New York. He was a longtime columnist for the&#160;<I>Chicago Tribune</I>&#160;in Washington, DC, and also wrote the Harrison Raines Civil War Mysteries. In 1993, with the help of illustrator Dick Locher, Kilian began writing the comic strip&#160;<I>Dick Tracy</I>. Kilian is buried in Arlington National Cemetery.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c13e493